const validator = {
  getMessage: field => `O campo ${field} deve ser maior que zero.`,
  validate: value => {
    if (value === 0) return false
    return true
  }
}

export default validator
